export default "__VITE_ASSET__DpoLruyc__"